import { removeAllAttachments } from "Store/AssetManagement/UploadAttachments/UploadAttachmentsAction";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { setReactivationAssetDetails, setTransferAssetDetails, setAssetError } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import { CONSTANTS } from "./constants";
import { setBillOfSaleUrl, setIsBillOfSaleCreated } from "Store/OrderManagement/BillOfSale/BillOfSaleAction";
// Resets Order Request value
const resetOrderRequest = (dispatch: any) => {
    dispatch(setReactivationAssetDetails({}));
    dispatch(setTransferAssetDetails({}));
    dispatch(TransferAction.setAssetData([]));
    dispatch(TransferAction.setAssetCartData([]));
    dispatch(TransferAction.setIDisposition([]));
    dispatch(TransferAction.setCartIDisposition([]));
    dispatch(TransferAction.setReactivationRequestData([]));
    dispatch(TransferAction.setTransferRequestData([]));
    dispatch(TransferAction.setAfeAssetDetailData({}));
    dispatch(TransferAction.setAfeBranchAddressDetail({}));
    dispatch(setAssetError(""))
    dispatch(removeAllAttachments())
}

const resetAllAssetOrderData = (dispatch: any) => {
    resetOrderRequest(dispatch);
    dispatch(TransferAction.setTransferOrderNumber(""));
    dispatch(TransferAction.setSelectedBranch(""));
    dispatch(TransferAction.setTransferOrderDetails({}));
    dispatch(removeAllAttachments());
    dispatch(TransferAction.setAfeAssetDetailData({}));
    dispatch(TransferAction.setAfeBranchAddressDetail({}));
    dispatch(TransferAction.setAfeOrderByIdData({}));
    dispatch(TransferAction.setSelectedRequestType(""));
    dispatch(setBillOfSaleUrl({}));
    dispatch(setIsBillOfSaleCreated(false));
}

const buildingImprovementsRequiredFields = [
    'invoicedAmount',
    'jeDescription',
    'addLine1',
    'addLine2',
    'assetCity',
    'assetState',
    'assetZip',
    'assetNumber',
    'attachments',
]

const furnitureFixturesRequiredFields = [
    'invoicedAmount',
    'jeDescription',
    'addLine1',
    'addLine2',
    'assetCity',
    'assetState',
    'assetZip',
    'attachments',
]

const LeaseImprovementsRequiredFields =[
    'invoicedAmount',
    'jeDescription',
    'addLine1',
    'addLine2',
    'assetCity',
    'assetState',
    'assetZip',
    'attachments',
    'leaseId',
    'leaseExpirationDate'
]

const fleetEquipmentRequiredFields = [
    'invoicedAmount',
    'jeDescription',
    'addLine1',
    'addLine2',
    'assetCity',
    'assetState',
    'assetZip',
    'assetNumber',
    'attachments',
    'repairRequest',
]

const AfeTypeFields = {
    [CONSTANTS.BUILDING_IMPROVEMENTS]: [
        'unitNumber',
        'year',
        'equipmentStatus',
        'netBookedValue',
        'equipmentClass',
        'cost',
        'vinSerialNumber',
        'licenseNumber',
        'description',
        'invoicedAmount',
        'descAndJustification',
        'address',
        'parentAssetNo',
    ],
    [CONSTANTS.FLEET_EQUIPMENT]: [
        'unitNumber',
        'year',
        'equipmentStatus',
        'netBookedValue',
        'equipmentClass',
        'cost',
        'vinSerialNumber',
        'licenseNumber',
        'description',
        'invoicedAmount',
        'descAndJustification',
        'address',
        'parentAssetNo',
        'isEfficiencyIncreased',
        'isLifeExtendedOneYear',
        'isRepairRequest',
        'isRepairValueOver1500'
    ],
    [CONSTANTS.LEASEHOLD_IMPROVEMENTS]: [
        'leaseId',
        'invoicedAmount',
        'descAndJustification',
        'address',
        'leaseExpirationDate'
    ],
    [CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP]: [
        'invoicedAmount',
        'descAndJustification',
        'address'
    ],
}

export {
    resetOrderRequest,
    resetAllAssetOrderData,
    buildingImprovementsRequiredFields,
    furnitureFixturesRequiredFields,
    LeaseImprovementsRequiredFields,
    fleetEquipmentRequiredFields,
    AfeTypeFields
}